<template>
  <div class="checkbox-container" style="position:relative;">
    <div class="el-checkbox">
      <span @click="changeCheckBox" class="el-checkbox__input" :class="{'is-checked':visible}">
        <span class="el-checkbox__inner"></span>
        <!-- <input
          type="checkbox"
          aria-hidden="false"
          class="el-checkbox__original"
          value
        /> -->
      </span>
      <span class="el-checkbox__label">
        <span @click="changeCheckBox">我已阅读并同意《隐私协议》</span><a @click.prevent="showPolicy">《个人信息授权声明》</a>
      </span>
    </div>
    <div>您的个人资料有可能会提交至长安马自达厂商及其授权经销商,与您进一步沟通试驾、购车等事宜。</div>
    <!-- <div class="tipBox" @click="goUrl('https://www.geely.com/geelynews/newslist/2019/201908014','tip')">&nbsp;</div> -->
  </div>
</template>
<script>
import { goUrl } from "@/utils/hybird"
import showPolicy from './dialog/policy/index'
export default {
  props: ["value"],
  data() {
    return {
      visible: false
    };
  },
  created() {
    this.visible = this.value;
  },
  methods: {
    showPolicy:(e)=>{
      e.preventDefault();
      showPolicy();
    },
    goUrl(url,linkId){
      goUrl(url,linkId)
    },
    changeCheckBox() {
      this.visible = !this.visible;
      this.$emit("input", this.visible);
    }
  }
};
</script>
<style lang="less" scoped="true">
.rem(@name,@px) {
    @{name}: unit(@px / 37.5, rem);
}
.checkbox-container{
  // display: grid;
  margin-top:15px;
  margin-left:auto;
  margin-right:auto;
  grid-template-columns: 50px auto;
  user-select: none;
  // margin-bottom: 16px;
  color: #fff;
  text-align: left;
  left: 5px;
  font-size: 10px;
  font-weight: bold;
  *{
    user-select: none;
  }
}
.tipBox {
  height: 20px;
  position: relative;
  z-index:20;
  left:20px;
  width:100px;
}
.el-checkbox {
  color:#fff;
  font-weight: bold;
  font-size: 10px;
  position: relative;
  cursor: pointer;
  display: flex;
  width: 300px;
  user-select: none;
  align-items: center;
  a{
    color:rgba(228, 196, 120, 1);
    border-bottom: 1px solid rgba(228, 196, 120, 1);
  }
  text-align: left;
}
.el-checkbox__input {
  cursor: pointer;
  outline: none;
  display: inline-block;
  top:0;
  vertical-align: middle;
  left:3px;
}
.el-checkbox__input.is-checked .el-checkbox__inner:before {
  content: "";
  display: block;
  background-color:rgba(228, 196, 120, 1);
  width:6px;
  height:6px;
  position: absolute;
  left:1px;
  top:1px;
}
.el-checkbox__inner {
  display: block;
  position: relative;
  border-radius: 2px;
  width:8px;
  height:8px;
  border:1px solid #fff;
  z-index: 1;
  top:-1px;
  right:5px;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
.el-checkbox__input.is-checked .el-checkbox__inner:after {
  transform: rotate(45deg) scaleY(1);
}
.el-checkbox__original {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  width: 0;
  height: 0;
  z-index: -1;
}
.el-checkbox__label {
  display: inline-block;
  line-height: 19px;
  font-size: 10px;
}
</style>
